import React from 'react';

interface FiClarifyMessageProps {
  text: string;
}

export const FiClarifyMessage: React.FC<FiClarifyMessageProps> = ({ text }) => {
  return (
    <div className="border-input-border-gray rounded-2xl border border-dashed bg-amber-50/80 px-4 py-3">
      <p className="font-open-sans text-sm leading-5 text-gray-900">{text}</p>
    </div>
  );
};
